const navigationMenu = {
  'USERS': 'Usuarios',
  'ROLES': 'Roles',
  'SECURITY': 'Seguridad',
  'Dealer Request': 'Peticiones de Dealer',
  'CONTROLLER_OPTION': 'Controlador',
  'HOLIDAY_OPTION': 'Vacación',
  'SCHEDULE_OPTION': 'Calendario',
  'ACCESSLEVEL_OPTION': 'Nivel de acceso',
  'GLOBALSETTINGS_OPTION': 'Ajustes globales',
  'EVENT_OPTION': 'Eventos',
  'ACCOUNT_INFO': 'Info de cuenta',
  'LOCKDOWN_OPTION': 'Aislamiento',
  'FLOOR_PLAN_OPTION': 'Plano',
  'HARDWARE': 'Hardware',
  'SETTINGS': 'Ajustes',
  'Reports': 'Reportes',
  'Input': 'Entrada de controladores',
  'Output': 'Salida de controladores',
  'firmware_manager': 'Administrador de Firmware',
  'ORGUSERS_REPORT': 'Reporte de Usuarios',
  'ORGCARDS_REPORT': 'Reporte de Credenciales',
  'Events': 'Reporte de Eventos',
  'INTERLOCK_OPTION': 'Interbloqueos',
  'CDVI_HELP_CONFIGURATION': 'Configuración de Ayuda',
  'banner_configuration': 'Configuración del banner',
  'STRIPE': 'Stripe',
  'menu': {
    home: 'Inicio',
    diagnose_controller: 'Diagnosticar controlador',
    new_session: 'Nueva sesión',
    open_sessions: 'Sesiones abiertas',
    current_session: 'Sesión actual',
    dealers: 'Distribuidores',
    dealer_requests: 'Solicitudes de distribuidor',
    accounts: 'Cuentas',
    help_configuration: 'Configuración de ayuda',
    stripe: 'Stripe',
    stripe_sync_issues: 'Problemas de sincronización Stripe',
    account_info: 'Info cuenta',
    credentials: 'Credenciales',
    doors: 'Puertas',
    events: 'Eventos',
    global_settings: 'Ajustes globales',
    hardware: 'Hardware',
    controllers: 'Controladores',
    outputs: 'Salidas',
    firmwares: 'Firmwares',
    notifications: 'Notificaciones',
    reports: 'Reportes',
    users: 'Usuarios',
    settings: 'Ajustes',
    holidays: 'Días festivos',
    schedules: 'Calendarios',
    access_levels: 'Niveles de acceso',
    lockdown: 'Aislamiento',
    floor_plans: 'Planos',
    interlocks: 'Interbloqueos',
    sites: 'Sitios',
    site_info: 'Info sitio',
    firmware_manager: 'Administrador de firmware',
    testing_tool: 'Herramienta de prueba',
    tasks: 'Tareas',
    anti_passback: 'Anti-passback',
  },
  'config': {
    profile: 'Perfil',
    dealer_info: 'Información del distribuidor',
    logout: 'Cerrar sesión',
    change_password: 'Cambia la contraseña',
    switch_profile: 'Cambiar perfil',
    language: 'Lenguaje',
  },
  'switch': {
    welcome: 'Bienvenido <1>{{ name }}</1>,',
    explanation:
      'Varios perfiles están asociados a tu usuario. Puedes cambiar entre ellos en cualquier momento aquí:',
    name: 'Nombre',
    last_login: 'Último inicio de sesión',
    actions: 'Acciones',
    login: 'Iniciar sesión',
    active_profile: 'Perfil activo',
    as_dealer: 'Como distribuidor',
    as_organization: 'Como organización',
    as_system: 'Como sistema',
  },
  'version': {
    label: 'Versión',
    copied: '¡Copiado!',
  },
  'section_customer_support': 'Atención al cliente',
  'section_administration': 'Administración',
  'section_account': 'Cuenta',
  'section_technical_support': 'Soporte técnico',
  'change_password_instruction_1':
    'Para cambiar su contraseña, cierre sesión primero.',
  'change_password_instruction_2':
    'En la pantalla de inicio de sesión, espere a que aparezca la opción "¿Olvidó su contraseña?" y haga clic en ella para seguir las instrucciones.',
};

export default navigationMenu;
